const apiKey = "d294f6fa68msh14a1595726431dap17ee21jsna6b2794c83ba";

const Words = {
	search(word) {
		return fetch(`https://wordsapiv1.p.rapidapi.com/words/${word}`, {
			"method": "GET",
			"headers": {
				"x-rapidapi-host": "wordsapiv1.p.rapidapi.com",
				"x-rapidapi-key": `${apiKey}`
			}
		})
		.then((response) => response.json())
		.then((jsonResponse) => {
			if (jsonResponse.results) {
				console.log(jsonResponse)
				return jsonResponse.results;
			} else {
				return [{"definition": "no results returned, please try another word.."}]
			}
		})
	}
}

export default Words;